export const AuditActionTypes = {
    LOGOUT: 'LOGOUT',
    COMMON_ERROR: 'COMMON_ERROR',

    NEW_AUDIT_REQUEST: 'NEW_AUDIT_REQUEST',
    NEW_AUDIT_REQUEST_SUCCESS: 'NEW_AUDIT_REQUEST_SUCCESS',
    NEW_AUDIT_REQUEST_ERROR: 'NEW_AUDIT_REQUEST_ERROR',
    NEW_AUDIT_REQUEST_STATUS: 'NEW_AUDIT_REQUEST_STATUS',

    AUDIT_LIST_REQUEST: 'AUDIT_LIST_REQUEST',
    AUDIT_LIST_REQUEST_SUCCESS: 'AUDIT_LIST_REQUEST_SUCCESS',
    AUDIT_LIST_REQUEST_ERROR: 'AUDIT_LIST_REQUEST_ERROR',

    AUDIT_DETAIL_REQUEST: 'AUDIT_DETAIL_REQUEST',
    AUDIT_DETAIL_REQUEST_SUCCESS: 'AUDIT_DETAIL_REQUEST_SUCCESS',
    AUDIT_DETAIL_REQUEST_ERROR: 'AUDIT_DETAIL_REQUEST_ERROR',

    AUDIT_ASSIGN_USER_REQUEST: 'AUDIT_ASSIGN_USER_REQUEST',
    AUDIT_ASSIGN_USER_REQUEST_SUCCESS: 'AUDIT_ASSIGN_USER_REQUEST_SUCCESS',
    AUDIT_ASSIGN_USER_REQUEST_ERROR: 'AUDIT_ASSIGN_USER_REQUEST_ERROR',
    AUDIT_ASSIGN_USER_REQUEST_STATUS: 'AUDIT_ASSIGN_USER_REQUEST_STATUS',

    AUDIT_UPDATE_STATUS_REQUEST: 'AUDIT_UPDATE_STATUS_REQUEST',
    AUDIT_UPDATE_STATUS_REQUEST_SUCCESS: 'AUDIT_UPDATE_STATUS_REQUEST_SUCCESS',
    AUDIT_UPDATE_STATUS_REQUEST_ERROR: 'AUDIT_UPDATE_STATUS_REQUEST_ERROR',
    AUDIT_UPDATE_STATUS_REQUEST_STATUS: 'AUDIT_UPDATE_STATUS_REQUEST_STATUS',

    AUDIT_ADD_LOG_REQUEST: 'AUDIT_ADD_LOG_REQUEST',
    AUDIT_ADD_LOG_REQUEST_SUCCESS: 'AUDIT_ADD_LOG_REQUEST_SUCCESS',
    AUDIT_ADD_LOG_REQUEST_ERROR: 'AUDIT_ADD_LOG_REQUEST_ERROR',
    AUDIT_ADD_LOG_REQUEST_STATUS: 'AUDIT_ADD_LOG_REQUEST_STATUS',

    AUDIT_UPDATE_LOG_STATUS_REQUEST: 'AUDIT_UPDATE_LOG_STATUS_REQUEST',
    AUDIT_UPDATE_LOG_STATUS_REQUEST_SUCCESS: 'AUDIT_UPDATE_LOG_STATUS_REQUEST_SUCCESS',
    AUDIT_UPDATE_LOG_STATUS_REQUEST_ERROR: 'AUDIT_UPDATE_LOG_STATUS_REQUEST_ERROR',
    AUDIT_UPDATE_LOG_STATUS_REQUEST_STATUS: 'AUDIT_UPDATE_LOG_STATUS_REQUEST_STATUS',

    AUDIT_ADD_LOG_COMMENT_REQUEST: 'AUDIT_ADD_LOG_COMMENT_REQUEST',
    AUDIT_ADD_LOG_COMMENT_REQUEST_SUCCESS: 'AUDIT_ADD_LOG_COMMENT_REQUEST_SUCCESS',
    AUDIT_ADD_LOG_COMMENT_REQUEST_ERROR: 'AUDIT_ADD_LOG_COMMENT_REQUEST_ERROR',
    AUDIT_ADD_LOG_COMMENT_REQUEST_STATUS: 'AUDIT_ADD_LOG_COMMENT_REQUEST_STATUS'
}
